import { io } from "socket.io-client";
import { apiUrl } from "../environment";

const URL = `${apiUrl}/`;

const socket = io(URL);

export default socket;
